/* eslint-disable */
import http from '@/utils/http';
import { getPageByStorage } from '@/utils/lockr';
import { IDENTITY_KEY_NAME } from '@/constants';
import { getIdentity } from '@/utils/detectDevice';
import xmlToJSON from 'xmltojson';


const list = async ({ id, attempt, stageId }) => http.apiGet(`/scorm/${await getIdentity(IDENTITY_KEY_NAME.UID, 0)}/${stageId}/${id}/${attempt}`);


const recordShare = async ({ id, attempt, stageId,new_attempt }) => http.apiGet(`/recordShare/${await getIdentity(IDENTITY_KEY_NAME.UID, 0)}/${stageId}/${id}/${new_attempt}/1`);
const xml = url => http.apiGetXml(url);
const localXml = name => xmlToJSON.parseString(getPageByStorage(name));

export default {
  list,
  xml,
  localXml,
  recordShare
};
